import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { EnrollmentStepWrapper } from "../styles/Enrollment.styled";
import { Button } from "../styles/Button.styled";
import { EnrollmentContext } from "../../enrollment";
import { ValidateZipcode } from "../../validate_zipcode";
import { fetchUtility, getAgentScript } from "../../api/api";
import { useLocation } from "react-router";
import qs from "qs";
import "moment/locale/es";

interface Props {
  show: boolean;
  isShowPlanModal: boolean;
  handleSwitchToTx: Function;
  planIsLoaded: boolean;
  handleConfirmUsn: Function;
  handleOpenUtilityModal: Function;
  setScriptData: any;
}

export const Zipcode: React.FC<Props> = ({
  show,
  isShowPlanModal,
  handleSwitchToTx,
  planIsLoaded,
  handleConfirmUsn,
  handleOpenUtilityModal,
}) => {
  const {
    handleSetErrorModalContent,
    usnZipcode,
    changeZipcode,
    changeUtilityList,
    selectedPlans,
    setLoading,
  } = useContext<any>(EnrollmentContext);

  const { t } = useTranslation("enrollment");
  const location = useLocation();
  const { promocode } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const [loadingUtility, setLoadingUtility] = useState(false);

  const searchUsnUtility = (zipcode: string) => {
    if (loadingUtility) return;
    changeUtilityList(undefined);
    changeZipcode("");
    setLoadingUtility(true);
    // setLoading(true);
    fetchUtility(zipcode, promocode).then((res) => {
      setLoadingUtility(false);
      setLoading(false); // for use in service step when redirecting from CRO
      if (res && res.status === 1) {
        const { utility, state } = res.response;
        if (state && state?.state_id !== "MD") {
          // MD is a special case, we do not service MD | 31-12-2024
          const stateId = state.state_id;
          getAgentScript();
          const isTx = stateId && stateId.toLowerCase().indexOf("tx") >= 0;
          if (isTx) {
            console.log("Texas zipcode detected!");
            changeUtilityList(undefined);
            handleSwitchToTx({
              zipcode: zipcode,
              utility: utility,
            });
          } else {
            handleConfirmUsn(true);
          }

          const [...utilityWithState] = utility;
          utilityWithState.forEach((item: any) => {
            if (!item.state) item.state = state;
            if (isTx) item.commodity_name = "Electric";
          });
          changeUtilityList(utilityWithState);
          changeZipcode(zipcode);
        } else {
          handleSetErrorModalContent({
            title: t(
              "We're sorry, CleanSky Energy currently does not service this area."
            ),
            desc: " ",
          });
          changeUtilityList(undefined);
        }
      } else {
        handleSetErrorModalContent({
          title: t(
            "We're sorry, CleanSky Energy currently does not service this area."
          ),
          desc: " ",
        });
        changeUtilityList(undefined);
      }
    });
  };

  const showInput = () => {
    return (
      <>
        <ValidateZipcode
          handleSearchUtility={(zipcode: string) => searchUsnUtility(zipcode)}
          loadingUtility={loadingUtility}
          defaultZipcode={usnZipcode}
        />
        {planIsLoaded &&
          selectedPlans.length === 0 &&
          usnZipcode &&
          !isShowPlanModal &&
          window.location.pathname !== "/zipcode" && (
            <div className="mt-3">
              <Button sm secondary onClick={() => handleOpenUtilityModal()}>
                Choose Plan
              </Button>
            </div>
          )}
      </>
    );
  };

  const currentUrl = new URL(window.location.href);
  if (!show) return null;
  if (currentUrl.searchParams.get("sign")) return null;
  return <EnrollmentStepWrapper>{showInput()}</EnrollmentStepWrapper>;
};
